import { TableCell, TableRow, Partnership } from '@/common'
import ReactCountryFlag from 'react-country-flag'

export default function ConnectedImporterRow({ partnership }: { partnership: Partnership }) {
  return (
    <TableRow key={partnership.id} className="w-full">
      <TableCell className="w-3/4">
        <div className="flex items-start gap-2">
          <ReactCountryFlag
            countryCode={partnership.country}
            className="relative top-1 shrink-0 size-4"
            svg
          />
          <span>{partnership.name}</span>
        </div>
      </TableCell>
    </TableRow>
  )
}
